import React, { useState } from 'react';
import { toast } from 'react-toastify';
import DefaultModal from 'components/Modal/DefaultModal';
import { Row, Col, FormGroup, Label, Input } from 'reactstrap';
import ReactButton from 'components/Buttons/ReactButton';
import ReactLoader from 'components/Loader';
import DialerService from '../../../../service';

const AddContactsModal = ({
  isModalOpen,
  onModalToggle,
  dialerId,
  reloadList,
  unmountOnClose
}) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async () => {
    if (!formData.name || !formData.phone) {
      toast.error('Nome e telefone são obrigatórios');
      return;
    }

    setLoading(true);

    try {
      await DialerService.createMalling({
        dialer_id: dialerId,
        contacts: [formData]
      });

      toast.success('Contato adicionado com sucesso');
      onModalToggle(false);
      if (reloadList) reloadList(1);
    } catch (error) {
      console.error('Erro ao adicionar contato:', error);
      toast.error(
        error.response?.data?.message ||
          'Erro ao adicionar contato. Tente novamente.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <DefaultModal
      show={isModalOpen}
      onModalToggle={onModalToggle}
      title="Adicionar Contato"
      showCloseButton={false}
      unmountOnClose={unmountOnClose}
    >
      {loading ? (
        <Row className="justify-content-md-center py-4">
          <ReactLoader />
        </Row>
      ) : (
        <>
          <Row>
            <Col>
              <FormGroup>
                <Label for="name">Nome *</Label>
                <Input
                  type="text"
                  name="name"
                  id="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormGroup>
                <Label for="phone">Telefone *</Label>
                <Input
                  type="text"
                  name="phone"
                  id="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  required
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormGroup>
                <Label for="email">Email</Label>
                <Input
                  type="email"
                  name="email"
                  id="email"
                  value={formData.email}
                  onChange={handleInputChange}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col className="d-flex justify-content-end">
              <ReactButton
                btnColor="secondary"
                type="button"
                size="sm"
                onClick={() => onModalToggle(false)}
                className="mr-2"
              >
                Cancelar
              </ReactButton>
              <ReactButton
                btnColor="confirmation"
                type="button"
                size="sm"
                onClick={handleSubmit}
                disabled={!formData.name || !formData.phone}
              >
                Adicionar
              </ReactButton>
            </Col>
          </Row>
        </>
      )}
    </DefaultModal>
  );
};

export default AddContactsModal;
